<template lang="pug">
  section.section.dark-black
    .container
      br
      //.hero-body
      .columns.is-centered
        .column
          .card.has-card-header-background
            header.card-header
              p.is-size-3.is-size-5-mobile.card-header-title
                | {{ language === 'en' ? 'Agent Partner Application Form' : '中介合作申请表' }}
              b-switch(v-model="language" true-value='cn' false-value='en')
                span.is-size-3.is-size-5-mobile Language: {{ language === 'cn' ? 'Chinese' : 'English' }}

            .card-content.no-padding-mobile
              .column.is-12.no-padding-mobile
                form.black-style(@submit.prevent="submit")
                  b-field(v-for="(formgroup, i) in form" :key="i" group-multiline grouped)
                    b-field.column.is-full-mobile(v-for="field in formgroup" :key="field.field")
                      b.is-size-4(v-if="typeof field === 'string'") {{translate(field)}}
                      b-field(v-else-if="field.options" :label="getLanguageLabel(field)")
                        b-autocomplete(
                          v-model="field.value"
                          :required='!field.optional'
                          :data="filteredDataObj"
                          open-on-focus
                          @select="option => selected = option"
                          )
                          // option(v-for="option in field.options" :key="option") {{ option }}
                      b-field.file(v-else-if="field.type === 'file'")
                        b-upload(v-model='field.value' :required='!field.optional')
                          a.button.is-primary.pagination-next
                            b-icon(icon='upload')
                            span {{ getLanguageLabel(field) }}
                        span.file-name(v-if='field.value')
                          | {{ field.value.name }}
                      b-field(v-else :label="getLanguageLabel(field)")
                        b-input(:required='!field.optional' v-model="field.value")
                  hr
                  .field.is-grouped.column
                    .control
                      b-button(type='is-primary' native-type='submit' :loading='submitting')
                        | {{translate('Submit')}}
      .hero-foot.has-text-centered
        .logo
</template>

<script>
import axios from 'axios'
import { API_ROOT } from '@/utils/constants/api'

const getDefaultData = () => process.env.NODE_ENV === 'production' ? '' : 'test data'

const getManagers = () => [
  "Bo O'Brien", 'Elena Yan',
  'Joni Tjhin', 'Michelle Li',
  'Mike Lin', 'Niranjan Phuyal',
  'Wayne Lim', 'Im Chanboracheat', 'Catherine Yang',
  'Frangklin Mewengkang', 'Flora Gu', 'Travis Liang', 'Tracy Le'
]

export default {
  name: 'Login',
  data () {
    return {
      language: 'en',
      submitting: false,
      form: [
        [
          { 'labelCn': '公司法定全称', 'label': 'Legal Name', 'field': 'legal_name', value: getDefaultData() },
          {
            'labelCn': '公司经营名称',
            'label': 'Trading Name',
            'field': 'trading_name',
            value: getDefaultData()
          },
          {
            'labelCn': '公司营业执照号',
            'label': 'ABN / Registration No',
            'field': 'registration_number',
            value: getDefaultData()
          }
        ],
        ['Company Address'],
        [
          {
            'labelCn': '街道名称',
            'label': 'Street Address',
            'field': 'address_street',
            value: getDefaultData()
          },
          { 'labelCn': '城市', 'label': 'City', 'field': 'address_city', value: getDefaultData() }, {
            'labelCn': '省份',
            'label': 'State / Province',
            'field': 'address_state',
            value: getDefaultData()
          },
          { 'labelCn': '邮编', 'label': 'Postal / Zip code', 'field': 'address_postal', value: getDefaultData() }, {
            'labelCn': '国家',
            'label': 'Country',
            'field': 'address_country',
            value: getDefaultData()
          }
        ],
        [
          { 'labelCn': '主要联系人', 'label': 'Main Contact Person', 'field': 'contact_person', value: getDefaultData() },
          {
            'labelCn': '职位',
            'label': 'Position',
            'field': 'position',
            value: getDefaultData()
          },
          { 'labelCn': '电话号码', 'label': 'Phone Number', 'field': 'phone', value: getDefaultData() },
          {
            'labelCn': '电子邮箱',
            'label': 'E-mail',
            'field': 'email',
            value: getDefaultData()
          }
        ],
        [
          {
            'labelCn': '请问以下哪位是首先联系贵司的Yes Education市场同事？',
            'label': 'Who is the Regional Marketing Executive/Manager that contacted you?',
            'field': 'yes_contact_person',
            'options': getManagers(),
            value: getDefaultData()
          }
        ],
        [
          {
            'labelCn': '财务负责人的电子邮箱地址',
            'label': 'Email address for finance related matter(s)',
            'field': 'email_finance',
            value: getDefaultData()
          },
          {
            'labelCn': '接受Yes Education发布的院校信息的电子邮箱地址',
            'label': 'Email address for Yes Education newsletter circulation',
            'field': 'email_newsletter',
            value: getDefaultData()
          }
        ],
        [
          {
            'labelCn': '贵司主要从哪些国家或地区招生？',
            'label': 'Which countries do you predominantly recruit students from?',
            'field': 'country_recruit_student_from',
            value: getDefaultData()
          }
        ],
        [
          {
            'labelCn': '公司营业执照扫描件（可选，不超过10MB）',
            'label': 'Company Registration Certificate (Optional, Maximum 10MB)',
            'field': 'company_certificate',
            'type': 'file',
            'optional': true,
            'value': null
          }
        ],
        [{
          'labelCn': '公司简介（可选，不超过10MB）',
          'label': 'Company Profile (Optional, maximum 10MB)',
          'field': 'company_profile',
          'type': 'file',
          'optional': true,
          'value': null
        }
        ],
        [{
          'labelCn': '公司银行信息（可选，不超过10MB）',
          'label': 'Company Bank Account Information For Commission Payment (Optional, maximum 10MB)',
          'field': 'company_bank_account',
          'type': 'file',
          'optional': true,
          'value': null
        }
        ]
      ]
    }
  },
  computed: {
    filteredDataObj () {
      return getManagers()
    }
  },
  methods: {
    translate (enString) {
      const dict = {
        'Nominated bank account details for commission transfer purpose:': '佣金银行账户:',
        'Submit': '提交',
        'Company Address': '公司地址:'
      }
      return this.language === 'cn' ? dict[enString] : enString
    },
    getLanguageLabel (field) {
      return this.language === 'cn' ? field.labelCn : field.label
    },
    async submit () {
      this.submitting = true
      const { form } = this

      let formData = new FormData()
      const jsonData = {}

      form.forEach(
        subform => {
          subform.forEach(
            field => {
              if (typeof field === 'object') {
                if (field.type !== 'file') {
                  jsonData[field.field] = field.value
                } else {
                  // file fields
                  if (field.value && field.value.size > 1e+7) {
                    this.$buefy.toast.open('File size exceeds limit of 10M!')
                  } else {
                    formData.append(field.field, field.value)
                  }
                }
              }
            }
          )
        }
      )
      // console.log(jsonData)
      // console.log(formData)
      formData.append('data', JSON.stringify(jsonData))

      try {
        const res = await axios.post(`${API_ROOT}/partner/create/`, formData)
        if (res.status === 201) {
          // success
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Successfully submitted, one of our friendly agent will be in contact shortly!'
          })
          window.scrollTo(0, 0)
        }
      } catch (e) {
        if (e && e.response && e.response.status === 400) {
          this.$buefy.toast.open('Something is wrong with the form, please check!')
        }
      }
      this.submitting = false
    }
  }
}

</script>

<style lang="scss">
  .is-dark-mode-active {
    section.dark-black {
      background-color: unset;
    }
  }

  .pagination-next {
    white-space: normal;
    height: auto;
  }
</style>

<style lang="scss" scoped>
  section {
    background-color: rgb(231, 195, 42);
  }

  .no-padding-mobile {
    @media (max-width: 400px) {
      padding: 0
    }
  }

  .black-style {
    a, button {
      background-color: black;
    }
  }
</style>
